<template>
  <vue-swing
      @throwout="onThrowout"
      :config="config"
      ref="vueswing"
  >
    <CardItem
        class="cursor-move"
        :class="[cardClass, { 'pointer-events-none': isTextCollapsed }]"
        :show-content="isCurrent"
        :options="options"
        v-on="$listeners"
    >
      <div class="flex flex-grow items-center justify-center">
        <TextQuestion class="text-center">
          <TextCollapsed
              :title="question.text"
              :max-length="question.imageSrc ? 100 : 300"
              @collapse="onCollapseTitle"
          />
        </TextQuestion>
      </div>

      <template #button>
        <div class="flex items-center justify-around w-full space-x-4">
          <a-button
              type="danger"
              class="hover:opacity-80 transition ease-in-out duration-150 pointer-events-auto"
              style="border-radius: 50px; padding: 8px 20px; height: auto;"
              :style="{
              transform: throwDirection === leftDirection ? 'scale(1.2)' : 'unset',
              filter: throwDirection === rightDirection ? 'grayscale(100%)' : 'unset',
               ...swipeButtonLeftBgColor,
               ...swipeButtonLeftTextColor,
            }"
              @click="swipe(leftDirection)"
          >
            {{ leftButton }}
          </a-button>
          <a-button
              type="primary"
              class="hover:opacity-80 transition ease-in-out duration-150 pointer-events-auto"
              style="border-radius: 50px; padding: 8px 20px; height: auto;"
              :style="{
              transform: throwDirection === rightDirection ? 'scale(1.2)' : 'unset',
              filter: throwDirection === leftDirection ? 'grayscale(100%)' : 'unset',
             ...swipeButtonRightBgColor,
             ...swipeButtonRightTextColor,
            }"
              @click="swipe(rightDirection)"
          >
            {{ rightButton }}
          </a-button>
        </div>

        <TextHelp
            v-if="survey.translations.questions.swipe.swipeDesc.active && !isTextCollapsed"
            class="w-full text-center flex items-center justify-center space-x-1 mt-2 -mb-1"
        >
          <a-icon type="arrow-left" />
          <div>
            {{
              survey.translations.questions.swipe.swipeDesc.value || survey.translations.questions.swipe.swipeDesc.defaultValue
            }}
          </div>
          <a-icon type="arrow-right" />
        </TextHelp>
      </template>
    </CardItem>
  </vue-swing>
</template>

<script>
import VueSwing from 'vue-swing'
import {questionEventListenerMixin, questionMixin} from "@/mixins/question";
import {mapGetters} from "vuex";
import themeMixin from "../../mixins/theme.mixin";
import TextHelp from "../TextHelp";
import CardItem from "../CardItem";
import TextCollapsed from "../TextCollapsed";
import TextQuestion from "../TextQuestion";

export default {
  name: "QuestionSwipe",
  props: {
    isCurrent: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({})
    },
  },
  components: {VueSwing, TextHelp, CardItem, TextCollapsed, TextQuestion},
  mixins: [questionMixin, questionEventListenerMixin, themeMixin],
  watch: {
    isCurrent: {
      handler(value) {
        if (value) {
          this.resetCard();
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      config: {
        allowedDirections: [
          VueSwing.Direction.LEFT,
          VueSwing.Direction.RIGHT
        ],
        minThrowOutDistance: window.outerWidth + 100,
        maxThrowOutDistance: window.outerWidth + 200,
        maxRotation: 10,
        throwOutConfidence: (xOffset, yOffset, element) => {
          let minXOffset = window.outerWidth > process.env.VUE_APP_MOBILE_WIDTH_BREAKPOINT ? 0.4 : 0.2;
          return Math.abs(xOffset) / element.offsetWidth >= minXOffset ? 1 : 0;
        },
      },
      leftDirection: VueSwing.Direction.LEFT,
      rightDirection: VueSwing.Direction.RIGHT,
      leftValue: 'no',
      rightValue: 'yes',
      throwDirection: '',
      isBeforeThrowout: false,
      isTextCollapsed: false,
      isAnswering: false,
    }
  },
  computed: {
    ...mapGetters(["survey"]),
    cardClass: function () {
      return this.isBeforeThrowout ? 'transition ease-in duration-100' : ''
    },
    leftButton() {
      return this.question.translations.leftButton.value || this.survey.translations.questions.swipe.leftButton.value || this.survey.translations.questions.swipe.leftButton.defaultValue
    },
    rightButton() {
      return this.question.translations.rightButton.value || this.survey.translations.questions.swipe.rightButton.value || this.survey.translations.questions.swipe.rightButton.defaultValue
    },
  },
  methods: {
    onThrowout({throwDirection}) {
      if (this.isAnswering) return;

      this.throwDirection = throwDirection;
      this.isAnswering = true;// Prevent multiple answers when drag the button
      this.isBeforeThrowout = true; // Set animation class before throw out

      let value = (throwDirection === this.leftDirection) ? this.leftValue : this.rightValue;

      this.onAnswer(value, 150);
    },

    swipe(throwDirection) {
      let cards = this.$refs.vueswing.cards;
      let coordX = 100;

      cards[cards.length - 1].throwOut(
          throwDirection === this.leftDirection ? -coordX : coordX,
          1
      );
    },

    onKeyDown(e) {
      if (!this.isCurrent) return;

      if (e.code === 'ArrowRight') {
        this.swipe(this.rightDirection);
      } else if (e.code === 'ArrowLeft') {
        this.swipe(this.leftDirection);
      }
    },

    resetCard() {
      this.isAnswering = false;
      this.isBeforeThrowout = false;
      this.isTextCollapsed = false;

      let cards = this.$refs.vueswing?.cards;
      if (cards) {
        cards[cards.length - 1].throwIn(1, 1);
      }
    },

    onCollapseTitle(value) {
      this.isTextCollapsed = value
    },
  }
}
</script>

<style lang="less" scoped>

</style>
